module.exports = __webpack_public_path__ + "static/media/logo.b542b333.png";